export const loggerStyle = {
  default: "color: #bada55",
  blue: "color: #4A9AF7",
  violet: "color: #FF5733",
  lightblue: "color: #D6EAF8",
  lightgreen: "color: #82E0AA",
  big: {
    greenOnYellow: "color: green; background: yellow; font-size: 20px",
  },
  force: {
    info: "color:white;background-color:dodgerblue;font-size:15px;",
  },
};
